
// axios
import axios from 'axios'

// eslint-disable-next-line import/no-cycle
import store from '../store'
import { getAccessToken, getUserLang, removeAccessToken } from './auth'

let isAlreadyFetchingAccessToken = false
let subscribers = []
function onAccessTokenFetched(accessToken) {
    subscribers = subscribers.filter(callback => callback(accessToken))
}

function addSubscriber(callback) {
    subscribers.push(callback)
}

const axiosIns = axios.create({
    baseURL: 'https://erp-integration.maktab.uz/',
    timeout: 1000,
    // headers: {'X-Custom-Header': 'foobar'}
})

axiosIns.interceptors.request.use(config => {
        // eslint-disable-next-line no-param-reassign
        config.headers['Content-Type'] = 'application/json'

        // eslint-disable-next-line no-param-reassign
        // config.headers.Accept = '*/*'
        // config.headers['Access-Control_Allow-Origin'] = "*"
        // config.headers['Access-Control-Allow-Credentials'] = true
        // eslint-disable-next-line no-param-reassign
        config.headers.Language = (getUserLang() ? getUserLang() : 'uz');
        if (getAccessToken()) {
            // eslint-disable-next-line no-param-reassign
            config.headers.Authorization = `Basic` + btoa("xtv:gm$m!E5tSQehe+%TVG2J=xghVmTkArbhHj6_NFL#" )
        }

        return config
    },
    error => {
        Promise.reject(error)
    })

axiosIns.interceptors.response.use(
    response => {
        if (response.message === 'Unauthenticated') {
            window.location = '/login'
        }

        return response
    },
    error => {
        const originalRequest = error.config
        if (error.response.message === 'Unauthenticated' && !getAccessToken()) {
            window.location = '/login'
        } else if (error.response.status === 401 && getAccessToken()) {
            if (!isAlreadyFetchingAccessToken) {
                isAlreadyFetchingAccessToken = true
                store.dispatch('auth/fetchAccessToken').then(res => {
                    isAlreadyFetchingAccessToken = false
                    onAccessTokenFetched(res.data.access)
                }).catch(() => {
                    removeAccessToken()
                    window.location = '/login'
                })
            }
            const retryOriginalRequest = new Promise(resolve => {
                addSubscriber(access_token => {
                    originalRequest.headers.Authorization = `Bearer ${access_token}`
                    resolve(axios(originalRequest))
                })
            })

            return retryOriginalRequest
        } else if (error.response.status === 405) {
            window.location = '/page-405'
        }
        return Promise.reject(error)
    },
)

// Vue.prototype.$http = axiosIns

export default axiosIns
